import React, { Component } from 'react';
import $ from 'jquery';
import { SvgIcon } from 'core/icons';

export default class BackToTop extends Component {
  constructor(props) {
    super(props);
    this.$window = $(window);
    this.$document = $(document);
    this.state = {
      displayBackToTop:
        window.scrollY > 1.5 * this.$window.height() &&
        this.$document.height() > 2 * this.$window.height()
    };
  }

  onScroll = () => {
    const oldDisplayValue = this.state.displayBackToTop;
    const displayBackToTop =
      window.scrollY > 1.5 * this.$window.height() &&
      this.$document.height() > 2 * this.$window.height();
    if (oldDisplayValue !== displayBackToTop) {
      this.setState({
        displayBackToTop
      });
    }
  };

  scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  render() {
    return (
      <button
        className={
          'stat-image-link back-to-top ' +
          (this.state.displayBackToTop
            ? 'back-to-top__show'
            : 'back-to-top__hide')
        }
        data-dtm="nav"
        onClick={this.scrollToTop}>
        <SvgIcon name="arrow-circle-up" />
      </button>
    );
  }
}
